import React, { useRef, useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { useSelector, useDispatch } from "react-redux"
import { Dispatch } from "redux"
import * as actions from './../../../shared/StoreContainer/actionCreators';
import { Layer, BaseLayer } from './../../../shared/StoreContainer/type';

import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import Interaction from 'ol/interaction/Interaction';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import VectorTileLayer from 'ol/layer/VectorTile';
import Draw from 'ol/interaction/Draw';
import MVT from 'ol/format/MVT.js';
import { OSM, XYZ } from 'ol/source';
import VectorTileSource from 'ol/source/VectorTile';
import { transform } from 'ol/proj';
import VectorTile from "ol/VectorTile";
import { Style, Stroke, Fill, RegularShape } from 'ol/style';

import { Config, UserContext } from './../../../App';
import { sendMetricAction } from '../../../shared/MetricApi';
import { getCenterCoordinates } from '../../../shared/RKApi';

import classNames from "./styles.module.scss"
import 'ol/ol.css';


export const DefaultStyle = new Style({
  stroke: new Stroke({
    color: "#6666F9",
    width: 1
  }),
  fill: new Fill({
    color: [255, 255, 255, 0.5]
  }),
});

export const SamplesStyle = new Style({
  stroke: new Stroke({
    color: "#D10015",
    width: 1
  }),
  fill: new Fill({
    color: [209, 0, 21, 0.5]
  }),
});

export const SamplesVerifiedStyle = new Style({
  stroke: new Stroke({
    color: "#FF954F",
    width: 1
  }),
  fill: new Fill({
    color: [255, 147, 79, 0.7]
  }),
});

export const SamplesUnverifiedStyle = new Style({
  stroke: new Stroke({
    color: "#FF0000",
    width: 1
  }),
  fill: new Fill({
    color: [255, 0, 0, 0.4]
  }),
});

export const SamplesMissedStyle = new Style({
  stroke: new Stroke({
    color: "#00A513",
    width: 1
  }),
  fill: new Fill({
    color: [0, 165, 19, 0.7]
  }),
});

export const SamplesHasLandsStyle = new Style({
  stroke: new Stroke({
    color: "#2064A3",
    width: 1
  }),
  fill: new Fill({
    color: [32, 100, 163, 0.6]
  }),
});

const SelectedStyle = new Style({
  stroke: new Stroke({
    width: 3,
    color: "#00FF00"
  }),
  fill: new Fill({
    color: "#00FF0020"
  })
});

export const SamplesOrangeStyle = new Style({
  stroke: new Stroke({
    color: "#FF6A00",
    width: 1
  }),
  fill: new Fill({
    color: [255, 106, 0, 0.5]
  }),
});

export const SamplesYellowStyle = new Style({
  stroke: new Stroke({
    color: "#D8B800",
    width: 1
  }),
  fill: new Fill({
    color: [216, 184, 0, 0.5]
  }),
});

const DrawStyle = new Style({
  stroke: new Stroke({
    color: "black",
    width: 3
  }),
  fill: new Fill({
    color: [255, 255, 255, 0]
  }),
  image: new RegularShape({
    fill: new Fill({ color: 'black' }),
    stroke: new Stroke({ color: 'black', width: 1 }),
    points: 100,
    radius: 5,
    rotation: 0,
    angle: 0
  })
})

export const makeStyle = (fillColor: any, lineColor: any) => {
  return new Style({
    stroke: new Stroke({
      color: lineColor,
      width: 1
    }),
    fill: new Fill({
      color: fillColor
    }),
  })
};


export const MapModule = () => {
  const dispatch: Dispatch<any> = useDispatch();

  //@ts-ignore
  const layersContainer = useSelector((state) => (state?.containerLayers));
  //@ts-ignore
  const baseLayersContainer = useSelector((state) => (state?.containerBaseLayers));
  //@ts-ignore
  const mapOpenedContainer = useSelector((state) => (state?.containerMapOpened));
  //@ts-ignore
  const objectClickContainer = useSelector((state) => (state?.containerObjectClick));
  //@ts-ignore
  const drawEnabledContainer = useSelector((state) => (state?.containerDrawEnabled));

  const mapElement = React.useRef<HTMLInputElement>(null)
  const mapRef = useRef<Map>();
  const [draw, setDraw] = useState<Interaction | undefined>()
  const [drawLayer, setDrawLayer] = useState<VectorLayer<VectorSource> | undefined>()
  const id = useContext(UserContext).id
  let { location } = useParams();
  const [locations, setLocations] = useState<[] | null>(null)
  const navigate = useNavigate()
  const [center, SetCenter] = useState<any>()
  const [vectorTileLayers, SetVectorTileLayers] = useState<any>({});

  let selectionLayer: VectorTileLayer | null = null;

  function addLayer(map: Map, name: string) {
    let need = true;
    map && map?.getLayers().getArray().forEach(layer => {
      if (layer.get('name') === name) need = false
    })
    if (need) {
      //@ts-ignore
      let layer = vectorTileLayers[name] || baseLayersContainer.baseLayers.find(baseLayer => (baseLayer.id === name)).layerObj;
      map.addLayer(layer);
    }
  }

  let removeLayer = (map: Map, name: string) => {
    map && map?.getLayers().getArray().forEach(layer => {
      if (layer.get('name') === name) {
        map.removeLayer(layer)
      }
    })
  }

  function stopDrawing(draw: Interaction | undefined, drawlayer: VectorLayer<VectorSource> | undefined) {
    draw && mapRef.current?.removeInteraction(draw)
    drawlayer && drawlayer.getSource()?.clear()
  }

  useEffect(() => {
    getCenterCoordinates(setLocations)
    let layers: Array<Layer> = layersContainer && layersContainer.layers;
    if (layers) {
      let vtl: any = {};
      layers.forEach(layer => {
        const vector = new VectorTileLayer({
          declutter: true,
          source: new VectorTileSource({
            format: new MVT(),
            url: layer.url,
            minZoom: layer.minZoom || 3,
            maxZoom: layer.maxZoom || 10,
            tileLoadFunction: function (tile, url: string) {
              (tile as VectorTile).setLoader(function (extent, resolution, projection) {
                fetch(url).then(function (response) {
                  response.arrayBuffer().then(function (data) {
                    const format = (tile as VectorTile).getFormat()
                    const features = format.readFeatures(data, {
                      extent: extent,
                      featureProjection: projection
                    });

                    for (let i = 0; i < features.length; i++) {
                      //@ts-ignore
                      features[i].hashId = Config?.featureId(features[i]);
                    }
                    (tile as VectorTile).setFeatures(features);
                  });
                });
              });
            }
          }),
        });
        vector.set('name', layer.id)
        vector.setStyle(layer.style || DefaultStyle);
        vector.setZIndex(1000);

        vtl[layer.id] = vector;
      })

      SetVectorTileLayers(vtl);
    }
    // eslint-disable-next-line
  }, [objectClickContainer, layersContainer])

  useEffect(() => {
    let baseLayers: Array<BaseLayer> = baseLayersContainer && baseLayersContainer.baseLayers;
    if (baseLayers) {
      baseLayers.forEach(baseLayer => {
        if (!baseLayer.layerObj) {
          baseLayer.layerObj = (baseLayer.type === "OSM") ?
            new TileLayer({
              preload: Infinity,
              source: new OSM(),
            })
            : (baseLayer.type === "TMS") ?
              new TileLayer({
                source: new XYZ({ url: baseLayer.url })
              })
              : {};

          baseLayer.layerObj.set('name', baseLayer.id);
          baseLayer.layerObj.setZIndex(100);
        }
      });
    }
  }, [baseLayersContainer])

  useEffect(() => {
    if (mapElement.current && !mapRef.current && center) {
      //@ts-ignore
      let defaultBaseLayer = baseLayersContainer && baseLayersContainer.baseLayers.find(baseLayer => baseLayer.turned);
      let baseSource = defaultBaseLayer && defaultBaseLayer.layerObj;
      if (!baseSource) {
        baseSource = new TileLayer({
          preload: Infinity,
          source: new OSM(),
        });
        baseSource.set('name', 'osm')
      }

      const sourceDraw = new VectorSource({ wrapX: false });
      const vectorDraw = new VectorLayer({
        source: sourceDraw,
        zIndex: 100,
        style: DrawStyle
      });
      vectorDraw.set('name', 'draw')

      mapRef.current = new Map({
        target: mapElement.current ? mapElement.current : undefined,
        layers: [baseSource, vectorDraw],
        view: new View({
          center: center,
          zoom: 6,
        })
      });

      mapRef.current.addEventListener('click', (e: any) => {
        let drawing = false;
        e.map.getInteractions().getArray().forEach((inter: any) => {
          if (inter.get('name') === 'draw') drawing = true
        });
        if (!drawing) {
          const pixel = e.map.getEventPixel(e.originalEvent);
          let features = e.map.getFeaturesAtPixel(pixel);

          let layers: Array<Layer> = layersContainer && layersContainer.layers;


          if (features.length > 0) {
            dispatch(actions.setObjectClick(features[0]));

            layers?.forEach(layer => {
              if (mapRef.current && layer.turned) {

                if (selectionLayer) {
                  mapRef.current.removeLayer(selectionLayer);
                }
                selectionLayer = new VectorTileLayer({
                  renderMode: 'vector',
                  source: vectorTileLayers[layer.id].getSource(),
                  style: (feature) => {
                    //@ts-ignore
                    if (features[0].hashId === feature.hashId) {
                      return SelectedStyle;
                    }
                  }
                })
                selectionLayer.set('name', "selection");
                selectionLayer.setZIndex(2000);
                mapRef.current.addLayer(selectionLayer);
              }
            })
          }
        }
      })

      let draw = new Draw({
        source: sourceDraw,
        type: "Polygon",
        freehand: true,
        style: DrawStyle
      });
      draw.on('drawend', function (e) {
        actions.complexActionForContact(dispatch, true, undefined);
        // const boxExtent = e.feature.getGeometry()?.getExtent();
        // console.log(boxExtent, e)
        // let arrayLayer = mapRef.current?.getAllLayers()
      });

      draw.on('drawstart', function (e) {
        sourceDraw && sourceDraw.clear()
      });

      draw.set('name', 'draw')
      setDraw(draw)
      setDrawLayer(vectorDraw)
    }
    //eslint-disable-next-line
  }, [mapElement, mapRef, center, selectionLayer]);

  useEffect(() => {
    if (locations && locations.length > 0) {
      locations.forEach(loc => {
        //@ts-ignore
        if (loc.urlpart === location && mapRef.current) {
          //@ts-ignore
          mapRef.current.getView().setCenter(transform([loc.lon, loc.lat], 'EPSG:4326', 'EPSG:3857'));
          //@ts-ignore
          mapRef.current.getView().setZoom(loc.zoom)

          dispatch(actions.setMapOpened(true));
        }
      });
    }
    else {
      let center2 = [5584030.684758671, 7021364.820491779]
      let getCoords = async () => {
        let showPosition = (position: { coords: { latitude: any; longitude: any; }; }) => {
          if (position) {
            center2 = [position.coords.latitude, position.coords.longitude]
            SetCenter(transform([center2[1], center2[0]], 'EPSG:4326', 'EPSG:3857'))
          }
        }
        await navigator?.geolocation?.getCurrentPosition(showPosition);

        SetCenter([center2[0], center2[1]])
      }
      getCoords()
    }
    // eslint-disable-next-line
  }, [locations, location])

  useEffect(() => {
    if (objectClickContainer.feature && locations) {
      locations.forEach(loc => {
        //@ts-ignore
        if (loc.name === objectClickContainer.feature.getGeometry().getProperties().territory_id) {
          //@ts-ignore
          navigate(Config.path.replace(':location?', loc.urlpart))
        }
      })
    }
  }, [locations, objectClickContainer, navigate])

  useEffect(() => {
    if (objectClickContainer.feature && id) {
      let feature = objectClickContainer.feature.getGeometry();
      let title = feature?.getProperties().territory_id;
      sendMetricAction(id, 'featureClick', title)
    }
  }, [id, objectClickContainer])

  useEffect(() => {
    if (draw) {
      // mapRef.current.removeInteraction(draw)
      drawEnabledContainer.enabled ? mapRef.current?.addInteraction(draw) : stopDrawing(draw, drawLayer)
    }
  }, [drawEnabledContainer])

  useEffect(() => {
    mapRef.current && removeLayer(mapRef.current, "selection");
    dispatch(actions.setObjectClick(null));
  }, [layersContainer])

  useEffect(() => {
    let layers: Array<Layer> = layersContainer && layersContainer.layers;
    if (layers && mapRef.current) {
      layers.forEach(layer => {
        if (mapRef.current) {
          if (layer.turned) {
            addLayer(mapRef.current, layer.id);

            if (layer.afterTurned) {
              layer.afterTurned(mapRef.current.getView());
            }
          }
          else {
            removeLayer(mapRef.current, layer.id);
          }
        }
      })

      if (mapOpenedContainer.coords) mapRef.current.getView().setCenter(mapOpenedContainer.coords);
    }
  }, [mapRef.current, layersContainer])

  useEffect(() => {
    let baseLayers: Array<BaseLayer> = baseLayersContainer && baseLayersContainer.baseLayers;
    if (baseLayers && mapRef.current) {
      baseLayers.forEach(baseLayer => {
        if (mapRef.current) {
          if (baseLayer.turned) {
            addLayer(mapRef.current, baseLayer.id);
          }
          else {
            removeLayer(mapRef.current, baseLayer.id);
          }
        }
      })
    }
  }, [mapRef, baseLayersContainer, mapOpenedContainer])

  return (
    <div ref={mapElement} style={{ pointerEvents: mapOpenedContainer.opened ? 'unset' : 'none' }} className={classNames.map} />
  );

}


